import { render, staticRenderFns } from "./SwappTasksUser.vue?vue&type=template&id=bf3f3ddc&scoped=true"
import script from "./SwappTasksUser.vue?vue&type=script&lang=js"
export * from "./SwappTasksUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3f3ddc",
  null
  
)

export default component.exports